































































































import Vue from "vue";
import VueCookie from "vue-cookie";

import config from "@/utils/cognitoUrlConfig";
import isMobile from "@/utils/isMobile";
import { getUser } from "@/utils/getUser";
import CookieService from "@/services/cookieService";
import AgreementService from "@/services/agreementService";
import ClockifyReportService from "@/services/clockifyReportService";
import CwDashboardService from "@/services/cwDashboardService";
import QsDashboardService from "@/services/qsDashboardService";
import ProjectService from "@/services/projectService";
import IntegrationService from "@/services/integrationService";
import AlertService from "@/services/alertService";
import SharedFilesService from "@/services/sharedFilesService";

export default Vue.extend({
  mixins: [isMobile],
  data() {
    const user = getUser();

    return {
      user: user,
      isLoggedIn: false,
      mobileView: true,
      showNav: false,
      disableNav: {
        agreement: true,
        finance: true,
        reports: true,
        projects: true,
        integrations: true,
        issues: true
      },
      jwt: ""
    };
  },
  methods: {
    onLogin(): void {
      window.location.href = `https://${config.hostName}/login?client_id=${config.clientId}&response_type=${config.responseType}&scope=${config.scope}&redirect_uri=${config.redirectUri}`;
    },
    onLogOut(): void {
      window.localStorage.removeItem("user");
      window.localStorage.removeItem("jwt");
      window.localStorage.removeItem("CloudFront-Policy");
      window.localStorage.removeItem("CloudFront-Signature");
      window.localStorage.removeItem("CloudFront-Key-Pair-Id");
      VueCookie.delete("CloudFront-Policy");
      VueCookie.delete("CloudFront-Signature");
      VueCookie.delete("CloudFront-Key-Pair-Id");
      window.location.href = `https://${config.hostName}/logout?client_id=${config.clientId}&redirect_uri=${window.location.origin}&response_type=token`;
    },
    checkLoginStatus(): boolean {
      const user = getUser();

      if (!user) {
        return false;
      }
      const currentTime = Math.floor(new Date().getTime() / 1000);
      const tokenExpiryDate = user.exp;

      if (tokenExpiryDate < currentTime) {
        return false;
      }
      this.user = user;
      return true;
    },
    parseJwt(token: string) {
      if (!token) return null;
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace("-", "+").replace("_", "/");
      return JSON.parse(window.atob(base64));
    }
  },
  async created() {
    if (!this.isLoggedIn) {
      const search = window.location.hash.toString().replace("#", "?");
      const urlParams = new URLSearchParams(search);
      const idToken = urlParams.get("id_token");

      if (idToken) {
        this.jwt = idToken;
        window.localStorage.setItem("user", JSON.stringify(this.parseJwt(idToken)));
        window.localStorage.setItem("jwt", idToken);
      }
    }

    const status = this.checkLoginStatus();
    if (status) {
      this.isLoggedIn = true;
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        //check agreement
        const agreementService = new AgreementService(jwt);
        agreementService.getAgreement().then(responseAgreement => {
          if (responseAgreement !== undefined && responseAgreement !== null) {
            if (responseAgreement.data && responseAgreement.data.files && responseAgreement.data.files.length) {
              this.disableNav.agreement = false;
            }
          }
        });

        // //check finance
        const crService = new ClockifyReportService(jwt);
        crService.getReport().then(responseClockifyReport => {
          if (responseClockifyReport !== undefined && responseClockifyReport !== null) {
            if (responseClockifyReport.data && responseClockifyReport.data.reports && responseClockifyReport.data.reports.length) {
              this.disableNav.finance = false;
            }
          }
        });

        //check projects
        const projectService = new ProjectService(jwt);
        const userGroups = this.user?.groups;
        projectService.getProjects(userGroups).then(responseProject => {
          if (responseProject && responseProject.status == 200) {
            if (responseProject.data && responseProject.data["topLevelIssues"].length) {
              this.disableNav.projects = false;
            }
          }
        });

        //check integrations
        const integrationService = new IntegrationService(jwt);
        integrationService.getIntegrations(userGroups).then(responseIntegration => {
          if (responseIntegration && responseIntegration.status == 200) {
            if (responseIntegration.data && responseIntegration.data["data"].length) {
              this.disableNav.integrations = false;
            }
          }
        });
        //check issue
        const alertService = new AlertService(jwt);
        alertService.getAlerts().then(responseAlert => {
          if (responseAlert !== undefined && responseAlert !== null) {
            if (responseAlert.data && responseAlert.data.alerts && responseAlert.data.alerts.length) {
              this.disableNav.issues = false;
            }
          }
        });

        //check reports
        const cw = new CwDashboardService(jwt);
        cw.getDashboards().then(cwResponse => {
          // eslint-disable-next-line no-empty
          if (cwResponse.status == 400) {
          } else {
            this.disableNav.reports = false;
          }
        });

        const qs = new QsDashboardService(jwt);
        qs.getDashboards().then(qsResponse => {
          // eslint-disable-next-line no-empty
          if (qsResponse.status == 400) {
          } else {
            this.disableNav.reports = false;
          }
        });

        const cookieService = new CookieService(jwt);
        const s = await cookieService.getCookie();
        const cookies = s.data.cookie;

        if (s !== undefined && s !== null) {
          window.localStorage.setItem(`CloudFront-Policy`, cookies[0].value);
          window.localStorage.setItem(`CloudFront-Signature`, cookies[1].value);
          window.localStorage.setItem(`CloudFront-Key-Pair-Id`, cookies[2].value);
          s.data.distributions.forEach(distro => {
            window.localStorage.setItem(`${distro.type}:url`, distro.url);
          });
        }
      }
    } else {
      this.onLogin();
    }
  }
});
